module.exports = __webpack_public_path__ + "img/top_news.fd8756be.jpg";